<template>
	<v-card elevation="0">
		<v-card-title class="font-weight-bold text--black">
			THÔNG BÁO
			<v-spacer></v-spacer>
			<v-btn icon @click="close">
				<v-icon> mdi-close </v-icon>
			</v-btn>
		</v-card-title>

		<v-card-text>
			<p>
				Phiếu ĐNTT này đã được lập UNC trước đó. Vui lòng kiểm tra kỹ
				trước khi tiếp tục để tránh lập trùng.
			</p>

			<v-data-table
				:headers="headers"
				:items="listData"
				hide-default-footer
				disable-pagination
				disable-sort
				dense
				class="elevation-0"
			>
				<template v-slot:[`item.code`]="{ item }">
					{{ item.code }}
				</template>

				<template v-slot:[`item.title`]="{ item }">
					{{ item.title }}
				</template>
			</v-data-table>
		</v-card-text>
		<v-card-actions class="white">
			<v-spacer></v-spacer>
			<v-btn
				:color="customColors['mbf-color-4']"
				elevation="0"
				dark
				class="rounded-0"
				@click="close"
			>
				{{ $t("button.ok") }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: "DialogWaning",
	components: {},
	props: ["listData"],

	data() {
		return {
			selectedItem: null,
			headers: [
				{
					text: "Số, ký hiệu",
					value: "code",
					align: "start",
					width: "20%",
				},
				{
					text: "Tiêu đề",
					value: "title",
					width: "80%",
				},
			],
		};
	},
	computed: {},
	async created() {
		console.log("listData", this.listData);
	},

	watch: {},
	methods: {
		close() {
			this.$emit("close", true);
		},
	},
	filters: {},
};
</script>

<style scoped></style>
